import { genfunction } from "helpers";
import {
    BOOKINGTYPES_LOADING, GET_BOOKINGTYPE_DATA, GET_BOOKINGTYPES_DATA_SUCCESS,
    GET_BOOKINGTYPES_DATA_ERROR, RESET_BOOKINGTYPES_DATA, REMOVE_UNUSED_BOOKINGTYPES
} from "../actions/actionBookingTypes";
import { loadState, saveState } from "../helpers/sessionStorage";

const sessionKey = "bookingTypes";

const initialState = {
    bookingID: 0,
    bookingTypes: loadState(sessionKey, []),
    bookingType: {},
    loading: false,
    bookingTypesError: ''
};

function reducerBookingTypes(state = initialState, action) {
    switch (action.type) {
        case BOOKINGTYPES_LOADING: {
            return {
                ...state,
                loading: true,
                bookingTypes: loadState(sessionKey, []),
                bookingType: {},
                bookingTypesError: ''
            };
        }

        case GET_BOOKINGTYPES_DATA_SUCCESS: {

            let bookingTypes = [
                ...state.bookingTypes
            ]

            if (bookingTypes.length > 0 && action.events && action.events.length > 0)
                bookingTypes = genfunction.RemoveUnUsedBookingTypes(bookingTypes, action.events);

            action.payload !== "nocontent" && action.payload.forEach(bookingType => {

                if (bookingTypes.find(x => x.BookingTypeID === bookingType.BookingTypeID)) {
                    bookingTypes = bookingTypes.filter(x => x.BookingTypeID !== bookingType.BookingTypeID);
                }

                bookingTypes.push(bookingType);
            });


            saveState(sessionKey, bookingTypes);


            return {
                ...state,
                loading: false,
                bookingTypes: bookingTypes,
                bookingType: bookingTypes && bookingTypes.length > 0 ? bookingTypes[0] : {},
                bookingTypesError: ''
            };
        }

        case REMOVE_UNUSED_BOOKINGTYPES: {
            let bkngTypes = [
                ...state.bookingTypes
            ]

            if (bkngTypes.length > 0 && action.events && action.events.length > 0) {
                bkngTypes = genfunction.RemoveUnUsedBookingTypes(bkngTypes, action.events);
                bkngTypes.push(bkngTypes);
            }

            saveState(sessionKey, bkngTypes);

            return {
                ...state,
                loading: false,
                bookingTypes: bkngTypes,
                bookingType: bkngTypes && bkngTypes.length > 0 ? bkngTypes[0] : {},
                bookingTypesError: ''
            };
        }

        case GET_BOOKINGTYPE_DATA: {

            return {
                ...state,
                loading: false,
                bookingType: action.payload,
                bookingTypesError: ''
            };
        }
        case RESET_BOOKINGTYPES_DATA: {

            saveState(sessionKey, []);

            return {
                ...state,
                bookingType: {},
                loading: false,
                bookingTypes: [],
                bookingTypesError: ''
            };
        }
        case GET_BOOKINGTYPES_DATA_ERROR: {
            return {
                ...state,
                loading: false,
                bookingTypes: action.payload,
                bookingTypesError: action.error
            }
        }

        default: {
            return state;
        }
    }
}

export default reducerBookingTypes;